import React from "react";

export default class ErrorBoundary extends React.Component
{
    constructor(props: any)
    {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: any)
    {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    render()
    {
        if (this.state.hasError)
        {
            return <div className="text-center" id='error'>
                <br />
                <h2 className="error-text">Something went wrong...</h2>
            </div>;
        }

        return this.props.children;
    }
}